import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from "../../component/utilities/Forms";
import * as CONST from "../../component/config/Constant";
import axios from "axios";
import { toast } from "react-toastify";
import { decrypt } from "./Helper";

function RoleSelection() {
  const { quizId: encryptedId } = useParams();
  const quizId = decrypt(encryptedId);
  const [activeRole, setActiveRole] = useState("guest");
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: "", phone: "", email: "" });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    // if phone field, restrict to digits and max length 10
    if (name === "phone") {
      // strip non-numeric characters
      let digits = value.replace(/\D/g, "");
      if (digits.length > 10) {
        // ignore extra characters or truncate
        digits = digits.slice(0, 10);
      }
      setFormData({ ...formData, phone: digits });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validation = Form.validator({
      name: { value: formData.name, label: "Name", isRequired: true },
      phone: {
        value: formData.phone,
        label: "Phone",
        isRequired: true,
        isPhone: true,
      },
      email: {
        value: formData.email,
        label: "Email",
        isRequired: true,
        isEmail: true,
      },
    });

    if (validation && validation.errors) {
      setErrors(validation.errors);
    } else {
      try {
        const response = await axios.post(`${CONST.GUEST}`, {
          name: formData.name,
          email: formData.email,
          phone_no: formData.phone,
        });

        if (response.data.status === "success") {
          toast.success("Guest details verified!");

          // Navigate to quiz with guest info in state
          navigate(`${CONST.ADMIN_PRE}user-quiz?startSet=${encryptedId}`, {
            state: {
              guestUser: {
                ...formData,
                guest_id: response.data.data.guest_id,
                isGuest: true,
              }
            }
          });
        }
      } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Error saving guest info");
      }
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh", backgroundColor: "#f4f7f6" }}
    >
      <div
        className="bg-white shadow-lg p-5"
        style={{ width: "500px", borderRadius: "15px" }}
      >
        <h2 className="text-center fw-bold mb-4">Start Assessment</h2>

        {/* Role Toggle */}
        <div className="row mb-4 g-2">
          <div className="col-6">
            <button
              className={`btn w-100 py-2 justify-content-center ${activeRole === "guest" ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => setActiveRole("guest")}
            >
              Take as Guest
            </button>
          </div>
          <div className="col-6">
            <button
              className={`btn w-100 py-2 justify-content-center ${activeRole === "employee" ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => setActiveRole("employee")}
            >
              Employee Login
            </button>
          </div>
        </div>

        {activeRole === "guest" ? (
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-semibold">Full Name</label>
              <input
                type="text"
                name="name"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && (
                <div className="invalid-feedback">{errors.name}</div>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Email Address</label>
              <input
                type="email"
                name="email"
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                placeholder="email@example.com"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Phone Number</label>
              <input
                type="text"
                name="phone"
                className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                placeholder="e.g. 9876543210 (max 10 digits)"
                value={formData.phone}
                onChange={handleChange}
                inputMode="numeric"
                maxLength={10}
              />
              {errors.phone && (
                <div className="invalid-feedback">{errors.phone}</div>
              )}
            </div>

            <button
              type="submit"
              className="btn btn-primary justify-content-center w-100 py-3 mt-2 shadow-sm"
            >
              Confirm & Start Quiz
            </button>
          </form>
        ) : (
          <div className="text-center py-4">
            <p className="text-muted mb-4">
              Logging in will save this assessment to your employee profile.
            </p>
            <button
              className="btn btn-dark w-100 py-3"
              onClick={() =>
                navigate(`/login?returnTo=/quiz/start/${encryptedId}`)
              }
            >
              Continue to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default RoleSelection;